<template>
  <v-card>
    <v-card-title></v-card-title>
    <v-card-text style="height: 70vh; align-items: center; overflow: auto">
      <v-row>
        <v-col class="flex-column pt-8">
          <v-img :src="require('@/assets/corrigendum_header.png')"
                 class="mb-8"></v-img>
          <v-textarea outlined
                      dense
                      auto-grow
                      no-resize
                      label="Center Header"
                      v-model="center_header"></v-textarea>
          <v-text-field outlined
                        dense
                        label="Left Header"
                        v-model="left_header"></v-text-field>
          <v-img :src="require('@/assets/corrigendum_footer.png')"
                 class="mb-8"></v-img>
          <v-text-field outlined
                        dense
                        label="Left Footer"
                        v-model="left_footer"></v-text-field>
          <v-text-field outlined
                        dense
                        type="number"
                        min="1"
                        label="Starting Page No."
                        v-model="starting_page_no"></v-text-field>
          <v-text-field outlined
                        dense
                        label="Right Footer"
                        v-model="right_footer"></v-text-field>
        </v-col>
      </v-row>
<!--      <PdfPreview v-for="section in sections"-->
<!--                  :section-id="section.id"></PdfPreview>-->
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit', false)"
             depressed
             large>
        {{ $t('close') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="exportPdf"
             large>
        EXPORT
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import PdfPreview from "@/views/PdfPreview";
import {ACTION_TYPES} from "@/store/types";
import {onMounted, ref} from "@vue/composition-api";

export default {
  name: 'CorrigendumPreviewModal',
  components: {PdfPreview},
  props: {
    corrigendumId: String,
    corrigendum: Object,
  },
  setup(props, {root, emit}) {
    const center_header = ref(null);
    const left_header = ref(null);
    const left_footer = ref(null);
    const starting_page_no = ref(1);
    const right_footer = ref(null);
    const sections = ref([]);
    const getSections = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/section/',
        params: {
          filters: {'sor.id': props.corrigendumId},
        },
      });

      if (response.body.success) {
        sections.value = response.body.sections;
      }
    }

    const exportPdf = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/corrigendum/export_pdf/',
        params: {
          corrigendum_id: props.corrigendumId,
          center_header: center_header.value,
          left_header: left_header.value,
          left_footer: left_footer.value,
          starting_page_no: starting_page_no.value,
          right_footer: right_footer.value,
        },
        opt: {extra: {responseType: 'arraybuffer'}},
      });

      let blob = new Blob([response.data], {type: response.headers.get('content-type')});
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = response.headers.get('file-name') || 'export.pdf';
      link.click();

      emit('submit', true);
    }
    const collectHeights = async function () {
      let heights = {
        'sub_section_header': {},
        'sub_section_category_header': {},
        'sub_sub_section': {},
      };
      const targets = [
        {cls: 'pdf-preview-sub-section-header', attribute: 'sub_section_header'},
        {cls: 'pdf-preview-sub-section-category-header', attribute: 'sub_section_category_header'},
        {cls: 'sub-sub-section', attribute: 'sub_sub_section'},
      ];

      targets.forEach((a) => {
        let elements = [...document.body.getElementsByClassName(a.cls)];

        elements.forEach((e) => {
          heights[a.attribute][e.id] = e.offsetHeight;
        })
      });

      // console.log(heights);

      let sub_sections = {};
      _.forEach(heights.sub_section_header, (value, key) => {
        sub_sections[key] = {
          header: value,
          category: heights.sub_section_category_header[key]
        };
      })

      let sub_sub_sections = {};
      _.forEach(heights.sub_sub_section, (value, key) => {
        sub_sub_sections[key] = value + 16;
      })

      let params = {
        sub_sections,
        sub_sub_sections,
      }

      console.log(JSON.stringify(params));

      // const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
      //   url: 'admin/corrigendum/set_heights/',
      //   params,
      // });
      //
      // if (response.body.success) {
      //   const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
      //     url: 'admin/corrigendum/export_pdf/',
      //     params: {
      //       corrigendum_id: props.corrigendumId,
      //       center_header: center_header.value,
      //       left_header: left_header.value,
      //       left_footer: left_footer.value,
      //       starting_page_no: starting_page_no.value,
      //       right_footer: right_footer.value,
      //     },
      //     opt: {extra: {responseType: 'arraybuffer'}},
      //   });
      //
      //   let blob = new Blob([response.data], {type: response.headers.get('content-type')});
      //   let link = document.createElement('a');
      //   link.href = window.URL.createObjectURL(blob);
      //   link.download = response.headers.get('file-name') || 'export.pdf';
      //   link.click();
      //
      //   emit('submit', true);
      // }
    }

    onMounted(() => {
      center_header.value = props.corrigendum.center_header || '';
      left_header.value = props.corrigendum.left_header || '';
      left_footer.value = props.corrigendum.left_footer || '';
      right_footer.value = props.corrigendum.right_footer || '';

      // getSections();
    })

    return {
      center_header,
      left_header,
      left_footer,
      starting_page_no,
      right_footer,
      sections,
      collectHeights,
      exportPdf,
    }
  }
}
</script>
